<script>
    function contact() {
        const email = 'aGVsbG9AbmFuZGFrZS5vcmc=';
        window.open(`mailto:${atob(email)}`, '_blank');
    }
</script>

<style lang="scss">
    footer {
        text-align: center;
        color: $subtle;
    }
</style>

<footer>
    <div class="wrapper">
        <p>
            Unless otherwise specified, all content is copyright &copy; 2020-2021 Nan Dake.<br>
            For business enquiries, contact me <a href="javascript:void(0);" on:click={contact}>by email</a>.
        </p>
    </div>
</footer>
